export default __webpack_public_path__ + "static/media/bg6.dc603b74.jpg";